import { useSetAtom } from 'jotai'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import type { Country } from 'internal-types/country.type'
import { countryToLanguage } from '../../../App'
import { useGoToHomePage } from '../home-list/HomeList.navigator'
import { countryAtom } from '../Home.state'

export const useCountry = () => {
  const { i18n } = useTranslation('global')
  const setCountryStorage = useSetAtom(countryAtom)
  const [country, setCountry] = useState<Country>()
  const homePage = useGoToHomePage()

  const onContinue = () => {
    setCountryStorage(country)
    homePage.go()
  }

  const onSelectCountry = (country: Country) => {
    setCountry(country)
    i18n
      .changeLanguage(countryToLanguage[country.toLowerCase()])
      .catch((err) => {
        console.error(err)
      })
  }

  return { country, actions: { onSelectCountry, onContinue } }
}
